import { render, staticRenderFns } from "./activity-data.vue?vue&type=template&id=53a662ef&scoped=true&"
import script from "./activity-data.vue?vue&type=script&lang=js&"
export * from "./activity-data.vue?vue&type=script&lang=js&"
import style0 from "./activity-data.vue?vue&type=style&index=0&id=53a662ef&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a662ef",
  null
  
)

export default component.exports